import { IComboCardProps } from '@/components/SeriesCombo';
import { EPlanDisplayMode, ESeriesCategory, ESIMCardStatus } from '@reolink-cloud/interface';

export const getComboCardList = ( currentPlanDisplayMode: EPlanDisplayMode, isAddOn: boolean ): IComboCardProps[] => {

    if ( isAddOn ) {

        return [{
            key: ESIMCardStatus.ACTIVE,
            isExpand: true,
            isShowSelect: true,
            type: ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN,
            showTitle: false
        }];

    }

    if ( currentPlanDisplayMode === EPlanDisplayMode.VIEW ) {

        return [{
            key: ESIMCardStatus.ACTIVE,
            isExpand: true,
            isShowSelect: false,
            type: ESeriesCategory.CLOUD_DATA_PLAN,
            showTitle: false
        }, {
            key: 'addon',
            isExpand: true,
            isShowSelect: false,
            type: ESeriesCategory.CLOUD_DATA_ADD_ON_PLAN,
            showTitle: true
        }];

    }

    return [{
        key: ESIMCardStatus.ACTIVE,
        isExpand: true,
        isShowSelect: true,
        type: ESeriesCategory.CLOUD_DATA_PLAN,
        showTitle: false
    }];

};
